import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { LogsService } from 'src/app/services/logs.service';

@Component({
  selector: 'habil-rejeicoes-fiscais',
  templateUrl: './rejeicoes-fiscais.component.html',
  styleUrls: ['./rejeicoes-fiscais.component.scss']
})
export class RejeicoesFiscaisComponent implements OnInit {

  filtro: any = { cnpj: '', cStat: null, modelo: '', ambiente: '', nroNota: '' };
  modelos = [{ label: 'Todos', value: '' }, { label: 'NF-e', value: 'NFE' }, { label: 'NFC-e', value: 'NFCE' }];
  ambientes = [{ label: 'Todos', value: '' }, { label: 'Produção', value: 'PRODUCAO' }, { label: 'Homologação', value: 'HOMOLOGACAO' }];

  lista: any[] = [];
  total = 0;
  retencaoDias = 14;
  length = 50;
  start = 0;
  resumo: any[] = [];
  loading = false;

  detalhe: any = null;
  mostraDetalhe = false;
  carregandoDetalhe = false;
  erro = '';

  constructor(private service: LogsService, breadcrumbService: BreadcrumbService) {
    breadcrumbService.setItems([{ label: 'Rejeições fiscais' }]);
  }

  ngOnInit(): void {
    this.carregaResumo();
  }

  buscar(start = 0) {
    this.start = start;
    this.loading = true;
    this.erro = '';
    this.service.getRejeicoesFiscais(start, this.length, this.filtro).subscribe({
      next: (r) => {
        this.loading = false;
        this.lista = r.list || [];
        this.total = r.total || 0;
        this.retencaoDias = r.retencaoDias || this.retencaoDias;
      },
      error: () => {
        this.loading = false;
        this.erro = 'Não foi possível buscar as rejeições no servidor de logs.';
      }
    });
  }

  carregaResumo() {
    this.service.getResumoRejeicoesFiscais().subscribe({
      next: (r) => this.resumo = r || [],
      error: () => this.resumo = []
    });
  }

  filtraPorCStat(cStat: number) {
    this.filtro.cStat = cStat;
    this.buscar();
  }

  /** Chamado pela tabela lazy, inclusive na primeira carga. */
  paginar(ev: any) {
    this.length = ev.rows;
    this.buscar(ev.first);
  }

  abrir(linha: any) {
    this.detalhe = { ...linha, xml: '' };
    this.mostraDetalhe = true;
    this.carregandoDetalhe = true;
    this.service.getRejeicaoFiscal(linha.id).subscribe({
      next: (r) => { this.detalhe = r; this.carregandoDetalhe = false; },
      error: () => { this.carregandoDetalhe = false; }
    });
  }

  baixarXml() {
    if (!this.detalhe || !this.detalhe.xml) {
      return;
    }
    const blob = new Blob([this.detalhe.xml], { type: 'application/xml' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `rejeicao-${this.detalhe.cnpj}-${this.detalhe.nroNota}-${this.detalhe.serie}.xml`;
    a.click();
    URL.revokeObjectURL(a.href);
  }
}
